import { render, staticRenderFns } from "./select_router_options.vue?vue&type=template&id=13d071e3&scoped=true"
import script from "./select_router_options.vue?vue&type=script&lang=js"
export * from "./select_router_options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d071e3",
  null
  
)

export default component.exports